import React from "react";
import { NavLink } from 'react-router-dom';
import '../../scss/Landing.css';

const ComingSoon = () =>{
    return(
        <div className="landingPage">
            <div className="left">
                <p className="heading">Coming Soon</p>
                <p className="bottomtag">Stay tuned!</p>
                <NavLink to="/" exact className="s-item" title='Form' activeClassName="active"> <button> <i class="fad fa-long-arrow-left"></i> Go Back </button>  </NavLink>

                
            </div>
            <div className="right">
                <img src="https://cdni.iconscout.com/illustration/premium/thumb/website-launching-coming-soon-2112253-1782224.png" alt="altimg" />
            </div>
        </div>
    )
}

export default ComingSoon;